"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _wouter = require("wouter");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _common = require("../../store/common");
var _Style = require("../../style/Style");
var _react = require("react");
var _form = require("../../components/form");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const App = props => {
  const [, setLocation] = (0, _wouter.useLocation)();
  const {
    newPassword,
    newPasswordConfirm,
    submitting,
    errors,
    verifyResetPasswordToken,
    resetPassword,
    setIsLoading,
    setToastText,
    setToastOpen,
    setLoadingMessage,
    checkNewPassword,
    setNewPassword,
    setNewPasswordConfirm
  } = (0, _common.useCommonStore)();
  const newPasswordRef = (0, _react.useRef)(null);
  const newPasswordConfirmRef = (0, _react.useRef)(null);
  const submitButtonRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    (async () => {
      setLoadingMessage('トークン確認中...');
      setIsLoading(true);
      const result = await verifyResetPasswordToken(props.token);
      setLoadingMessage('');
      setIsLoading(true);
      if (!result) {
        setToastText('認証URLが無効です。');
        setLocation('/');
        return;
      }
      setIsLoading(false);
    })();
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    ...stylex.props(_Style.wrapper.main, _Style.wrapper.noSidebar),
    spacing: 4,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      container: true,
      ...stylex.props(_Style.wrapper.mainTitle),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.textStyle.h1),
        children: "\u30D1\u30B9\u30EF\u30FC\u30C9\u518D\u8A2D\u5B9A"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      spacing: 2,
      direction: 'column',
      ...stylex.props(_Style.wrapper.stretchW),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldInput, {
        label: "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9",
        ref: newPasswordRef,
        type: "password",
        value: newPassword,
        errorText: errors.newPassword,
        placeholder: '新しいパスワードを入力してください)',
        onChange: event => {
          setNewPassword(event.target.value);
        },
        onEnterKey: () => {
          var _newPasswordConfirmRe;
          (_newPasswordConfirmRe = newPasswordConfirmRef.current) === null || _newPasswordConfirmRe === void 0 ? void 0 : _newPasswordConfirmRe.focus();
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldInput, {
        label: "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9(\u78BA\u8A8D\u7528)",
        ref: newPasswordConfirmRef,
        type: "password",
        value: newPasswordConfirm,
        errorText: errors.newPasswordConfirm,
        placeholder: '新しいパスワード(確認用)を入力してください)',
        onChange: event => {
          setNewPasswordConfirm(event.target.value);
        },
        onEnterKey: () => {
          var _submitButtonRef$curr;
          (_submitButtonRef$curr = submitButtonRef.current) === null || _submitButtonRef$curr === void 0 ? void 0 : _submitButtonRef$curr.focus();
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        ...stylex.props(_Style.buttonStyle.primary),
        disabled: submitting,
        ref: submitButtonRef,
        onClick: async () => {
          setIsLoading(true);
          if (!(await checkNewPassword())) {
            setIsLoading(false);
            return;
          }
          setIsLoading(false);
          if (!window.confirm('パスワードを変更しますか？')) {
            return;
          }
          setIsLoading(true);
          const result = await resetPassword(props.token, newPassword);
          if (!result) {
            setIsLoading(false);
            return false;
          }
          setToastOpen(true);
          setToastText('パスワードの再設定が完了しました');
          setLocation('/');
          setIsLoading(false);
          return;
        },
        children: submitting ? 'パスワード変更中...' : 'パスワードを変更する'
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
        minHeight: 48,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ...stylex.props(_Style.textStyle.error),
          children: errors.submit
        })
      })]
    })]
  });
};
var _default = exports.default = App;